import { useEffect } from 'react';
import * as clocks from '@/events/services/clocks';

function useClock(tickHandlerName) {
    useEffect(() => {
        const clocksTimer = clocks.start(tickHandlerName);
        return () => {
            clocks.stop(clocksTimer);
        };
    }, [tickHandlerName]);
}

export default useClock;
